import {
  MOBILE_WIDTH,
  TABLET_PORTRAIT_WIDTH,
  TABLET_LANDSCAPE_WIDTH,
  DESKTOP_WIDTH,
  DESKTOP_LARGE_WIDTH,
} from '../../../helpers/constants/responsive-breakpoints';

export const mediaQueries = {
  mobile: `${MOBILE_WIDTH}px`,
  tabletPortrait: `${TABLET_PORTRAIT_WIDTH}px`,
  tabletLandscape: `${TABLET_LANDSCAPE_WIDTH}px`,
  desktop: `${DESKTOP_WIDTH}px`,
  desktopLarge: `${DESKTOP_LARGE_WIDTH}px`,
};

const breakpoints = Object.values(mediaQueries);

const spaceValues = {
  0: 0,
  4: 4,
  8: 8,
  10: 10,
  12: 12,
  16: 16,
  20: 20,
  24: 24,
  32: 32,
  48: 48,
};

const spaceNames = {
  gutter: spaceValues[20],
  none: spaceValues[0],
  xsmall: spaceValues[4],
  small: spaceValues[8],
  medium: spaceValues[12],
  large: spaceValues[16],
  xlarge: spaceValues[32],
};

const space = {
  ...spaceValues,
  ...spaceNames,
};

const theme = {
  breakpoints,
  space,
};

const compareIfNamed = (a, b) => {
  const isNamed = x => /^[a-z]+$/.test(x);
  return isNamed(a) && isNamed(b) ? a : isNamed(a) && -1;
};

export const spacingProps = Object.keys(space).sort(compareIfNamed);

export default theme;
